//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BannerCard',
  props: {
    banner: { type: Object, required: false, default: null },
    srpBannerMinHeight: { type: Boolean, default: false }
  },
  setup(props) {
    const img = computed(() => props.banner?.image || '');
    const alt = computed(() => props.banner?.title || '');
    const link = computed(() => ({
      url: props.banner?.link || '#',
      target: '_self',
      rel: 'nofollow sponsored noopener'
    }));

    return { img, alt, link };
  }
});
